import { FC } from 'react';
import { observer } from 'mobx-react-lite';

import { DataView, DetailBadge, DetailBody, DetailCloseButton, DetailHeader } from 'components';
import { store } from 'store';

import { ShipActionButton } from './components';
import * as S from './ShipPanel.styles';

export const ShipPanel: FC = observer(() => {
  const { mode, resetMode } = store.commonStore;
  const { portfolio, wallets: copiedWallets } = store.portfolioStore;

  const balance = portfolio?.deposit ?? null;
  const pnl = portfolio?.totalPnl ?? null;

  return (
    <S.ShipDetailPanel isActive={mode === 'pilot' || mode === 'autopilot'} type="info">
      <DetailHeader>
        <DetailBadge type="info">COPY-TRADING PILOT</DetailBadge>
        <DetailCloseButton onClick={resetMode} />
      </DetailHeader>
      <DetailBody>
        <S.StatsRow>
          <S.StatSection>
            <S.Label>DEPOSIT</S.Label>
            <S.Value>
              <DataView value={balance} type="dollars" toFixed={2} />
            </S.Value>
          </S.StatSection>
          <S.StatSection $withBorder>
            <S.Label>PNL</S.Label>
            <S.Value>
              <DataView value={pnl} type="dollars" toFixed={2} hasSign hasColor />
            </S.Value>
          </S.StatSection>
        </S.StatsRow>
        <S.Actions>
          <S.CopiedWalletsLabel>
            COPIED WALLETS <span>{copiedWallets.length}</span>
          </S.CopiedWalletsLabel>
          <S.ActionsButtons>
            <ShipActionButton
              variant="deposit"
              onClick={() => store.copyFormStore.openCopyModal('deposit')}
            >
              Deposit
            </ShipActionButton>
            <ShipActionButton
              variant="withdraw"
              onClick={() => store.copyFormStore.openCopyModal('withdraw')}
            >
              Withdraw
            </ShipActionButton>
          </S.ActionsButtons>
        </S.Actions>
      </DetailBody>
    </S.ShipDetailPanel>
  );
});
